import { RAIN_FADE_REGION_DATA } from './rain-fade.constants'

// Helper function to get rain value for a region and QoS
export const getRainValue = (region: string, qos: number): number => {
  const entry = RAIN_FADE_REGION_DATA.find(data => data.region === region && data.qos === qos)
  return entry?.rain ?? 0
}